import { graphql } from "@/graphql/codegen"

import "@/screens/Accounting/subfeatures/Invoices/graphql/invoice.fragment"

graphql(`
  query GetPayableApprovalInvoiceList($input: InvoiceListInput!) {
    invoice {
      list(input: $input) {
        __typename
        ... on InvoiceListSuccess {
          invoices {
            ...InvoiceListExpandedRowFields
          }
          pageInfo {
            offset
            limit
            total
          }
        }
        ... on InvoiceListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
